import React from 'react';
import styled from 'styled-components';
import { useContent } from '@sparknz/journeys-common';
import { Box, InfoStrip } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { environmentVariables } from 'shared/utils/environment.utils';
import { ResponseData } from '../../types/bannerContent.types';
import BannerItem from './components/BannerItem';

const FlexBox = styled(Box)`
  display: flex;
`;

const DeviceGalleryBanner = () => {
  const { data: response } = useContent<ResponseData>({
    apiBaseUrl: environmentVariables.apiURL,
    contentId: 'gallery-promo-banner',
    modelId: 'multiline-banner-model',
    persistedQuery: 'multiline-banner-model-list',
    variation: 'promobanner',
    format: 'json',
  });

  const urlItems =
    response?.data?.multiLineBannerModelList?.Banners[0]?.bannerDetails[0]
      ?.urlAndDescription;

  if (!urlItems?.length) return null;

  return (
    <LinkRegion regionId="banner.galleryPage">
      <InfoStrip>
        <FlexBox flexWrap="wrap" justifyContent="center" gap="s1">
          {urlItems.map((urlItem, index) => (
            <BannerItem
              key={urlItem.urlLink}
              urlAndDescription={urlItem}
              isFirst={index === 0}
            />
          ))}
        </FlexBox>
      </InfoStrip>
    </LinkRegion>
  );
};

const MemoizedDeviceGalleryBanner = React.memo(DeviceGalleryBanner);
export default MemoizedDeviceGalleryBanner;
